import React from 'react';

const ServerContentDone = ({item}) => {
  return (
    <div className="server_content_wraper">
      <div className={`server_content_img ${item.color}`}>
        <img src={item.avatar} alt="" />
        <div
          className={`info_pay_server ${item.pay === 'silver' ? 'silver' : ''} ${
            item.pay === 'gold' ? 'gold' : ''
          } ${item.pay === 'free' ? 'free' : ''}  `}>
          <img src="./img/server/infopay.svg" alt="" />
        </div>
      </div>
      <div className="server_content_name">{item.name}</div>
      <div className="server_content_folower">
        <img src="./img/server/Followers.svg" alt="" />
        {item.memberCount}
      </div>
      <div className="server__info-owner">{item.status}</div>
    </div>
  );
};

export default ServerContentDone;
